import {apiGet, apiPut} from "./api";

export const getListEmail = async (searchParams) => {
    return await apiGet(`/list-email`, searchParams);
}

export const updateListEmail = async (body) => {
    return await apiPut(`/list-email`, body);
}
